import store from "@/store";

const hasPendingSubmissionsHook = (_to, _from, next) => {
  if (store.getters.hasPendingSubmissions) {
    confirmUserRouteChange({ next });
    return;
  }

  next();
};

const confirmUserRouteChange = ({ next }) => {
  const formList = store.getters.formattedPendingSubmissionsList;
  const message = `Você tem dados não salvos em ${formList}. Tem certeza de que deseja sair?`;

  const userConfirmed = window.confirm(message);

  if (userConfirmed) {
    store.commit("resetFormPendingSubmissions");
  }

  next(userConfirmed);
};

export { hasPendingSubmissionsHook };
